import { en, he } from '@locales';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import axiosInstance from '@api/axiosInstance';

const setLangAttribute = lng => {
    document.documentElement.lang = lng;
    document.documentElement.dir = i18n.dir(lng);
    axiosInstance.defaults.headers.common['Accept-Language'] = lng;
};

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources: {
            en,
            he,
        },
        ns: ['general', 'controls', 'search', 'prompts'],
        defaultNS: 'general',
        // lng: 'en',
        fallbackLng: 'en',
        parseMissingKeyHandler: key => key.split('.').pop(),
        interpolation: {
            escapeValue: false,
            prefix: '{',
            suffix: '}',
        },
    });

setLangAttribute(i18n.language);
i18n.on('languageChanged', setLangAttribute);

export default i18n;
